<template>
  <div class="right-side-wrap">
    <router-link to="/usercenter/infomanagement" class="side">
      <el-image
        src="https://download.zhidiancloud.com/mro/images/20240521/c85cb707-9cd5-4fff-b4b6-f5515d7b6440.svg"
        fit="contain"
        class="w-13px mx-auto !flex items-center"
      ></el-image>
      <p>我的</p>
    </router-link>

    <router-link to="/shoppingcart" class="side" id="rightShopCar" @click.native="hinaClickShopCart">
      <el-badge
        :value="productStore.shoppingcartNum"
        :hidden="productStore.shoppingcartNum == 0"
        class="item"
        :max="99"
      >
        <!-- <i class="el-icon-s-goods animate__animated" :class="{ animate__swing: productStore.shopIconShake }"></i> -->
        <el-image
          src="https://download.zhidiancloud.com/mro/images/20240521/37ac9bc7-51c9-42b6-bcb8-3d3f99070d1e.png"
          fit="contain"
          class="w-13px mx-auto !flex items-center"
          :class="{ animate__swing: productStore.shopIconShake }"
        ></el-image>
      </el-badge>

      <p>购物车</p>
    </router-link>
    <router-link to="/usercenter/coupon" class="side" id="rightShopCar" ref="sideCouponRef">
      <el-badge :value="couponNum" :hidden="couponNum == 0" class="item" :max="99">
        <!-- <i class="el-icon-s-goods animate__animated" :class="{ animate__swing: productStore.shopIconShake }"></i> -->
        <el-image
          src="https://download.zhidiancloud.com/mro/images/20240521/9fab37dc-2741-462d-a4bb-33c25735e70f.svg"
          fit="contain"
          class="w-13px mx-auto !flex items-center"
        ></el-image>
      </el-badge>

      <p>优惠券</p>
    </router-link>
    <router-link to="/favorites" class="side">
      <i class="el-icon-star-on"></i>
      <p>收藏夹</p>
    </router-link>
    <el-popover
      placement="left-end"
      title="智电云商城官方客服"
      width="150"
      trigger="hover"
      style="margin-top: 10px; display: block"
    >
      <div class="text-center">
        <img src="@/assets/images/customerService.png" alt="微信客服" />

        <el-link href="https://work.weixin.qq.com/kfid/kfc8aaed7d6d8e7f4fb" target="_blank"
          ><el-button type="primary" size="mini">在线咨询</el-button></el-link
        >
      </div>
      <span class="side" slot="reference">
        <el-image
          src="https://download.zhidiancloud.com/mro/images/20240521/c8cbb320-0192-4fc5-8f48-5ad86cd8f7f4.svg"
          fit="contain"
          class="w-13px mx-auto !flex items-center"
        ></el-image>
        <p>客服</p>
      </span>
    </el-popover>
    <el-popover
      v-if="appStores.isInner"
      placement="left-end"
      title="智电云商卖家小程序"
      width="150"
      trigger="hover"
      style="margin-top: 10px; display: block"
    >
      <div class="text-center">
        <img src="@/assets/images/卖家版.jpg" alt="微信客服" />
      </div>
      <span class="side" slot="reference">
        <el-image
          src="https://download.zhidiancloud.com/mro/images/20240521/1f6479c8-0000-419b-bcdf-21c5f234902e.svg"
          fit="contain"
          class="w-13px mx-auto !flex items-center"
        ></el-image>
        <p>小程序</p>
      </span>
    </el-popover>
    <el-popover
      v-else
      placement="left-end"
      title="智电云商买家小程序"
      width="150"
      trigger="hover"
      style="margin-top: 10px; display: block"
    >
      <div class="text-center">
        <img src="@/assets/images/买家版.jpg" alt="微信客服" />
      </div>
      <span class="side" slot="reference">
        <el-image
          src="https://download.zhidiancloud.com/mro/images/20240521/1f6479c8-0000-419b-bcdf-21c5f234902e.svg"
          fit="contain"
          class="w-13px mx-auto !flex items-center"
        ></el-image>
        <p>小程序</p>
      </span>
    </el-popover>

    <div class="side toTop" v-scroll-to="{ el: '#top-point' }" v-show="appStores.scrollTop > 100">
      <i class="el-icon-caret-top"></i>
      <p>顶部</p>
    </div>
    <couponNotify :offSet="sideCouponoffSet"></couponNotify>
  </div>
</template>
<script lang="ts" setup>
import { appInfo } from '@/stores/appInfo';
import { productInfo } from '@/stores/productInfo';
import { userInfo } from '@/stores/userInfo';
import { getCouponCount } from '@/api/coupon';
import * as hinaApi from '@/utils/hina';
import couponNotify from './rightSide/couponNotify.vue';
const appStores = appInfo();
const userStore = userInfo();
const productStore = productInfo();
// 优惠券偏移高度
const sideCouponRef = ref();
const sideCouponoffSet = ref(0);
//保持购物车数据为最新
onMounted(() => {
  document.addEventListener('visibilitychange', checkShopCart);
  console.log('sideCouponRef.value.offsetTop: ', sideCouponRef.value);

  sideCouponoffSet.value =
    (sideCouponRef.value?.$el?.offsetParent?.offsetTop ?? 0) + (sideCouponRef.value?.$el?.offsetTop ?? 0);
});

onBeforeUnmount(() => {
  document.removeEventListener('visibilitychange', checkShopCart);
});
function checkShopCart() {
  if (userStore.isLogin) {
    if (document.visibilityState !== 'hidden') {
      if (useRoute().path !== '/shoppingcart') {
        productStore.getCartNum();
      }
    }
  }
}

// 获取优惠券数量
const couponNum = ref(0);
function initCouponCount() {
  getCouponCount().then(res => {
    couponNum.value = res.data;
  });
}
watch(
  () => userStore.isLogin,
  (newValue, oldValue) => {
    if (newValue) {
      initCouponCount();
    }
  }
);

// 点击购物车埋点
function hinaClickShopCart() {
  hinaApi.headerCartClickPoint({
    inlet: 3,
  });
}
</script>
<style lang="scss" scoped>
.right-side-wrap {
  position: fixed;
  right: 10px;
  top: 40vh;
  z-index: 2;

  .side {
    display: block;
    background: #fff;
    border-radius: 3px;
    padding: 8px;
    margin-top: 10px;
    text-align: center;
    box-shadow: 0 0 5px 3px $main-shadow-color;
    color: $main-text-color1;
    position: relative;
    cursor: pointer;

    p {
      margin: 4px 0 0;
      font-size: 12px;
    }

    &:first-child {
      margin: 0;
    }

    ::v-deep .el-badge__content.is-fixed {
      right: 0;
    }
  }

  .toTop {
    margin-top: 40px;
    cursor: pointer;
  }
}
</style>
